export const FIELD_SCHEMAS = {
  bms: [
    {name:'nome', label:'Nome da BM', type:'text', required:true},
    {name:'plataforma', label:'Plataforma', type:'select', options:['Meta','Google Ads','TikTok Ads','Outra']},
    {name:'status', label:'Status', type:'select', options:['ativo','em revisão','banido']},
    {name:'facebookId', label:'ID da BM no Facebook', type:'text', hint:'Preenchido automaticamente na importação. Só preencha se for cadastrar à mão.'},
    {name:'observacao', label:'Observações', type:'textarea'}
  ],
  contas: [
    {name:'nome', label:'Nome da conta', type:'text', required:true},
    {name:'cliente', label:'Cliente', type:'text'},
    {name:'bmId', label:'BM vinculada', type:'select', dynamic:'bms'},
    {name:'plataforma', label:'Plataforma', type:'select', options:['Meta','Google Ads','TikTok Ads','Outra']},
    {name:'status', label:'Status', type:'select', options:['ativa','em revisão','desativada']},
    {name:'limiteGasto', label:'Limite de gasto diário (R$)', type:'number', step:'0.01'},
    {name:'idMeta', label:'ID da conta no Meta (act_...)', type:'text'}
  ],
  campanhas: [
    {name:'nome', label:'Nome da campanha', type:'text', required:true},
    {name:'contaId', label:'Conta de anúncio', type:'select', dynamic:'contas'},
    {name:'cliente', label:'Cliente', type:'text'},
    {name:'loja', label:'Loja Shopify', type:'text'},
    {name:'produto', label:'Produto', type:'text'},
    {name:'idMeta', label:'ID da campanha no Meta Ads', type:'text', hint:'Está no Gerenciador de Anúncios (coluna "Identificação da campanha"). Necessário pra pausar, ativar e mudar orçamento pelo painel.'},
    {name:'objetivo', label:'Objetivo', type:'select', options:['Vendas','Conversão','Leads','Tráfego','Reconhecimento','Engajamento']},
    {name:'status', label:'Status', type:'select', options:['ativa','pausada','finalizada']},
    {name:'dataInicio', label:'Data de início', type:'date'},
    {name:'orcamentoTipo', label:'Tipo de orçamento', type:'select', options:['Diário','Total']},
    {name:'orcamento', label:'Orçamento (R$)', type:'number', step:'0.01', group:'money'},
    {name:'gasto', label:'Gasto atual (R$)', type:'number', step:'0.01', group:'money'},
    {name:'receita', label:'Receita gerada (R$)', type:'number', step:'0.01', group:'money'},
    {name:'impressoes', label:'Impressões', type:'number', step:'1', group:'perf'},
    {name:'cliques', label:'Cliques no link', type:'number', step:'1', group:'perf'},
    {name:'visualizacoes', label:'Visualizações da página', type:'number', step:'1', group:'perf'},
    {name:'checkouts', label:'Inícios de checkout', type:'number', step:'1', group:'perf'},
    {name:'conversoes', label:'Conversões', type:'number', step:'1', group:'perf'}
  ],
  rejeitados: [
    {name:'nomeAnuncio', label:'Nome do anúncio', type:'text', required:true},
    {name:'contaId', label:'Conta de anúncio', type:'select', dynamic:'contas'},
    {name:'motivo', label:'Motivo da rejeição', type:'textarea'},
    {name:'data', label:'Data', type:'date'},
    {name:'status', label:'Status', type:'select', options:['em recurso','perdido','reaprovado']}
  ],
  meta: [
    {name:'valorObjetivo', label:'Meta de lucro do mês', type:'number', step:'0.01', required:true, hint:'Na moeda base escolhida no topo (BRL ou USD).'}
  ],
  saude: [
    {name:'metaLojas', label:'Meta de lojas vendendo ao mesmo tempo', type:'number', step:'1', required:true},
    {name:'metaContas', label:'Meta de contas de anúncio ativas', type:'number', step:'1', required:true, hint:'A nota sobe conforme as vendas se dividem entre lojas e o gasto entre contas. Loja e conta vêm do cadastro de cada campanha ativa.'}
  ],
  faturamento: [
    {name:'deducaoPct', label:'Taxas, descontos e reembolsos (% das vendas)', type:'number', step:'0.01', required:true, hint:'Faturamento líquido = bruto − esse percentual.'}
  ],
  admins: [
    {name:'name', label:'Nome', type:'text'},
    {name:'email', label:'E-mail', type:'text'},
    {name:'role', label:'Papel', type:'select', options:['admin']}
  ],
  lojasShopify: [
    {name:'nome', label:'Nome da loja', type:'text', hint:'Se vazio, usamos o nome retornado pela Shopify.'},
    {name:'shop_domain', label:'Domínio Shopify', type:'text', hint:'ex.: minhaloja.myshopify.com'},
    {name:'client_id', label:'Client ID', type:'text', hint:'Só se esta loja usa um app próprio. No login da Shopify, deixe em branco.'},
    {name:'webhook_secret', label:'Client secret', type:'password', hint:'Só se esta loja usa um app próprio. No login da Shopify, deixe em branco.'},
    {name:'status', label:'Status', type:'select', options:['ativa','pausada']}
  ],
  adminsEdit: [
    {name:'name', label:'Nome', type:'text'},
    {name:'role', label:'Papel', type:'select', options:['admin']},
    {name:'status', label:'Status', type:'select', options:['ACTIVE','INACTIVE']}
  ]
};

export const TYPE_LABELS = { bms:'BM', contas:'conta de anúncio', campanhas:'campanha', rejeitados:'anúncio rejeitado', admins:'administrador', lojasShopify:'loja Shopify' };
